// Utilities
import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => ({
    loading: false,
    djangoUrl: import.meta.env.VITE_DJANGO_ENDPOINT,
    environment: import.meta.env["VITE_ENVIRONMENT"]
  }),
})
